import React from "react";
import PaymentDetail from "./PaymentDetail";

const PaymentDetailPage: React.FC = () => {
  return <PaymentDetail />;
};

export default PaymentDetailPage;
